import { ApiDatasource } from '../../adapters/io/datasources/ApiDatasource';
import { unwrap } from '../../adapters/io/network/HttpResponse';
import { formatText } from '../../adapters/io/network/utils';
import { ApiDatasourceSpec } from '../../core/datasource';
import { AuthState } from '@okta/okta-auth-js';
import { buildHeader } from './utils/Utils';
import { Order } from '../../../../graphics/tables/operations/sort';
import {CountryTableStructure} from "../indexes/CountryIndexes";

export const getCountryRecords = <T>(
    authState: AuthState,
    search: CountryTableStructure.FormattedSearchValue[],
    page?: number,
    limit?: number,
    order?: Order,
    orderBy?: string | number,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<CountryTableStructure.ResponseOf<T>> => {

    const params = new Map();
    const body = {
        fieldSearches : search
    }
    page !== undefined && params.set('page', page);
    limit !== undefined && params.set('limit', limit);
    order !== undefined && params.set('order', order);
    orderBy !== undefined && params.set('orderBy', orderBy);

    return datasource.remote
        .postData<CountryTableStructure.ResponseOf<T>, CountryTableStructure.ListOfFormattedSearchValue>(
            uriFormatter(EndpointCountry.endPoint.concat(EndpointCountry.getCountries), {}),
            body, buildHeader(authState), params)
        .then(unwrap);
};

export const getCountryByStoreRecords = <T>(
    authState: AuthState,
    search: CountryTableStructure.FormattedSearchValue[],
    page?: number,
    limit?: number,
    order?: Order,
    orderBy?: string | number,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<CountryTableStructure.ResponseOf<T>> => {

    const params = new Map();
    const body = {
        fieldSearches : search
    }
    page !== undefined && params.set('page', page);
    limit !== undefined && params.set('limit', limit);
    order !== undefined && params.set('order', order);
    orderBy !== undefined && params.set('orderBy', orderBy);

    return datasource.remote
        .postData<CountryTableStructure.ResponseOf<T>, CountryTableStructure.ListOfFormattedSearchValue>(
            uriFormatter(EndpointCountry.endPoint.concat(EndpointCountry.getCountriesByStore), {}),
            body, buildHeader(authState), params)
        .then(unwrap);
};

export const EndpointCountry = {
    endPoint: '/end-point/country',
    getCountries: '/search',
    getCountriesByStore: '/search-store'
};